"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStoresUrlSlugPatchRequestToJSON = exports.ApiStoresUrlSlugPatchRequestFromJSONTyped = exports.ApiStoresUrlSlugPatchRequestFromJSON = exports.instanceOfApiStoresUrlSlugPatchRequest = void 0;
var StoreUpdate_1 = require("./StoreUpdate");
/**
 * Check if a given object implements the ApiStoresUrlSlugPatchRequest interface.
 */
function instanceOfApiStoresUrlSlugPatchRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "store" in value;
    return isInstance;
}
exports.instanceOfApiStoresUrlSlugPatchRequest = instanceOfApiStoresUrlSlugPatchRequest;
function ApiStoresUrlSlugPatchRequestFromJSON(json) {
    return ApiStoresUrlSlugPatchRequestFromJSONTyped(json, false);
}
exports.ApiStoresUrlSlugPatchRequestFromJSON = ApiStoresUrlSlugPatchRequestFromJSON;
function ApiStoresUrlSlugPatchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'store': (0, StoreUpdate_1.StoreUpdateFromJSON)(json['store']),
    };
}
exports.ApiStoresUrlSlugPatchRequestFromJSONTyped = ApiStoresUrlSlugPatchRequestFromJSONTyped;
function ApiStoresUrlSlugPatchRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'store': (0, StoreUpdate_1.StoreUpdateToJSON)(value.store),
    };
}
exports.ApiStoresUrlSlugPatchRequestToJSON = ApiStoresUrlSlugPatchRequestToJSON;
